'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/editable-field.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _icon = require('@marmalade/icon');
var _icon2 = _interopRequireDefault(_icon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var EditableField = function (_Component) {
  _inherits(EditableField, _Component);
  function EditableField() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, EditableField);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditableField.__proto__ || Object.getPrototypeOf(EditableField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editing: false,
      value: _this.props.text
    }, _this.handleInputChange = function (e) {
      _this.setState({
        value: e.target.value
      });
    }, _this.showInput = function () {
      _this.setState({
        editing: true
      });
    }, _this.cancelEdit = function () {
      _this.setState({
        editing: false,
        value: _this.props.text
      });
    }, _this.handleSave = function () {
      _this.props.onSave(_this.state.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(EditableField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.text !== nextProps.text) {
        this.setState({
          editing: false,
          value: nextProps.text
        });
      }
      if (typeof this.props.error === 'undefined' && typeof nextProps.error !== 'undefined') {
        this.setState({
          editing: true
        });
      }
    }
  }, {
    key: 'createInput',
    value: function createInput() {
      return _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        },
        __self: this
      }, _react2.default.createElement('input', {
        type: 'text',
        value: this.state.value,
        onChange: this.handleInputChange,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }), typeof this.props.error !== 'undefined' && _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        },
        __self: this
      }, this.props.error), _react2.default.createElement(_button2.default, {
        text: 'Cancel',
        onClick: this.cancelEdit,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        },
        __self: this
      }), _react2.default.createElement(_button2.default, {
        text: 'Save',
        prominence: 'primary',
        onClick: this.handleSave,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        },
        __self: this
      }));
    }
  }, {
    key: 'createEditButton',
    value: function createEditButton() {
      return _react2.default.createElement('span', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        },
        __self: this
      }, _react2.default.createElement(_icon2.default, {
        type: 'pen',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76
        },
        __self: this
      }), ' Edit');
    }
  }, {
    key: 'createText',
    value: function createText() {
      return _react2.default.createElement('div', {
        onClick: this.showInput,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83
        },
        __self: this
      }, this.props.text, this.createEditButton());
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.isFetching) {
        return _react2.default.createElement(_loading2.default, {
          inline: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 92
          },
          __self: this
        });
      }
      return _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94
        },
        __self: this
      }, this.state.editing ? this.createInput() : this.createText());
    }
  }]);
  return EditableField;
}(_react.Component);
EditableField.propTypes = {
  text: _propTypes.string.isRequired,
  onSave: _propTypes.func.isRequired,
  isFetching: _propTypes.bool,
  error: _propTypes.string
};
EditableField.defaultProps = {
  isFetching: false,
  error: undefined
};
exports.default = EditableField;